export default  {
  search_text: '请输入您想要搜索的内容',
  food_list: '餐饮清单',
  '搜索':'搜索',
  '商品清单空空的~':'商品清单空空的~',
  '件商品':'件商品',
  '收起':'收起',
  '展开':'展开',
  '删除':'删除',
  '总计': '总计',
  '去结算':'去结算',
  '库存不足':'库存不足， 请减少购买数量',
  '商品已变更,请重新购买': '商品已变更,请重新购买'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/foodList.js